var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, EventEmitter } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { HasSubscriptions } from '../../has-subscriptions';
import { CommunicationService } from '../../../services/communication.service';
import { ListingCategory } from '../../../classes/enums';
import { PreferencesService } from '../../../services/preferences.service';
var RightNavComponent = /** @class */ (function (_super) {
    __extends(RightNavComponent, _super);
    function RightNavComponent(userService, communicationService, preferencesService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.communicationService = communicationService;
        _this.preferencesService = preferencesService;
        _this.showRightNav = false;
        _this.toFavourites = new EventEmitter();
        _this.toSavedSearches = new EventEmitter();
        _this.openSignIn = new EventEmitter();
        _this.toMyAccount = new EventEmitter();
        _this.logout = new EventEmitter();
        _this.toFavouriteAgent = new EventEmitter();
        _this.onCloseRightNavClick = new EventEmitter();
        _this.ListingCategory = ListingCategory;
        _this.addSub(_this.preferencesService.favouriteAgentUrlChanged.subscribe(function (url) { return _this.agentUrl = url; }));
        return _this;
    }
    RightNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.userService.currentUser.subscribe(function (currentUser) { return _this.currentUser = currentUser; }));
        this.addSub(this.communicationService.listings.currentShownListingType.subscribe(function (listingType) { return _this.currentListingType = listingType; }));
    };
    return RightNavComponent;
}(HasSubscriptions));
export { RightNavComponent };
